var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.options)?_c('Modal',{attrs:{"name":_vm.name}},[_c('template',{slot:"default"},[_c('base-colors',_vm._b({attrs:{"component":_vm.component}},'base-colors',_vm.options,false))],1)],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }